import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { routes } from '~/routes';
import { useUserSelector } from './useUserSelector';

const REFERRAL_QUERY_PARAM = 'referral';
const SHORT_LINK_QUERY_PARAM = 'branch_url';

export const useReferralHandler = () => {
  const navigate = useNavigate();
  const user = useUserSelector();
  const { search } = useLocation();

  useEffect(() => {
    const qs = new URLSearchParams(search);
    const referralId = qs.get(REFERRAL_QUERY_PARAM);
    const shortLink = qs.get(SHORT_LINK_QUERY_PARAM);

    if (user && referralId) {
      navigate(routes.referral, { state: { shortLink } });
      localStorage.removeItem('referralId');
      return;
    }

    if (referralId) {
      localStorage.setItem('referralId', referralId);
    }
  }, [user]);

  const clearReferral = () => {
    localStorage.removeItem('referralId');
  };

  const getReferral = () => localStorage.getItem('referralId') || '';

  const handleReferral = (code) => {
    if (user) {
      return;
    }

    localStorage.setItem('referralId', code);
  };

  return { clearReferral, getReferral, handleReferral };
};
